import React, { useState, useEffect } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import {
  Col,
  Container,
  Row,
  Form,
  InputGroup,
  FormControl,
  Table,
} from "react-bootstrap";
import { Breadcrumbs, Button, Typography } from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet";
import Slider from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
import "../../../node_modules/rc-tooltip/assets/bootstrap.css";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import {
  base_url,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Ringbildermenu from "../../Components/ringbildermenu";
import { toast } from "react-toastify";
import ReplayIcon from "@mui/icons-material/Replay";
import { isMobileOnly, isTablet } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListIcon from "@mui/icons-material/List";
import AppsIcon from "@mui/icons-material/Apps";
import IonRangeSlider from "react-ion-slider";
import placeholderImg from "../../Assets/images/DFL/diamond-dfl-img.png";

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const RingSettingsDiamonds = (props) => {
  const locationofurl = useLocation();

  const history = useHistory();
  const [productCount, setProductCount] = useState(0);
  const [view, setView] = useState(1);
  const [page, setPage] = useState(1);
  const [diamondList, setDiamondList] = useState([]);
  const [shape, setShape] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.shape
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.shape
      : ""
  );

  const [caratrange, setCaratrange] = useState([]);
  const [carat, setCarat] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.carat
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.carat
      : []
  );
  const [pricerange, setPricerange] = useState([]);
  const [price, setPrice] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.price
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.price
      : []
  );
  const [leavemouse, setLeavemouse] = useState(false);
  const [cut, setCut] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.cut
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.cut
      : [0, 100]
  );
  const [cutdata, setCutdata] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.cutdata
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.cutdata
      : []
  );
  const [color, setColor] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.color
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.color
      : [0, 100]
  );
  const [colordata, setColordata] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.colordata
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.colordata
      : []
  );
  const [clarity, setClarity] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.clarity
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.clarity
      : [0, 100]
  );
  const [claritydata, setClaritydata] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.claritydata
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.claritydata
      : []
  );
  const [fluorescence, setFluorescence] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.fluorescence
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.fluorescence
      : [0, 100]
  );
  const [fluorescencedata, setFluorescencedata] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.fluorescencedata
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.fluorescencedata
      : []
  );
  const [polish, setPolish] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.polish
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.polish
      : [0, 100]
  );
  const [polishdata, setPolishdata] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.polishdata
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.polishdata
      : []
  );
  const [symmetry, setSymmetry] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.symmetry
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.symmetry
      : [0, 100]
  );
  const [symmetrydata, setSymmetrydata] = useState(
    JSON.parse(localStorage.getItem("dfl_d_filter"))?.symmetrydata
      ? JSON.parse(localStorage.getItem("dfl_d_filter"))?.symmetrydata
      : []
  );
  const [filter, setFilter] = useState([]);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [countLoader, setCountLoader] = useState(true);
  const [sortby, setSortby] = useState("");
  const [inputchange, setInputchange] = useState(false);
    const [filterCleared, setFilterCleared] = useState(false);

  const [diamond_type, setDiamond_type] = useState(
    window.location.pathname == "/diamonds/lab" ? 2 : 1
  );
  const [clearFdata, setClearFdata] = useState(false);
  const [titleHeading, settitleHeading] = useState(null);

  const dispatch = useDispatch();

  const clearFilter = () => {
    setFilterCleared(true)
    localStorage.removeItem("dfl_d_filter");
    setShape("");
    setCarat([
      filter?.normal_filters?.carat?.min,
      filter?.normal_filters?.carat?.max,
    ]);
    setPrice([
      filter?.normal_filters?.price?.min,
      filter?.normal_filters?.price?.max,
    ]);
    setCut([0, 100]);
    setCutdata([]);
    setColor([0, 100]);
    setColordata([]);
    setClarity([0, 100]);
    setClaritydata([]);
    setFluorescence([0, 100]);
    setFluorescencedata([]);
    setPolish([0, 100]);
    setPolishdata([]);
    setSymmetry([0, 100]);
    setSymmetrydata([]);
    setSortby(filter?.sort_by[0]?.value);
    setClearFdata(!clearFdata);
  };
  useEffect(() => {
    if (
      locationofurl?.pathname?.includes("/shape=") ||
      locationofurl?.pathname?.includes("/style=") ||
      locationofurl?.pathname?.includes("/material=14K-") ||
      locationofurl?.pathname?.includes("/metals=") ||
      locationofurl?.pathname?.includes("/metal=")
    ) {
      return history
        .push(
          props.location.pathname
            ?.replaceAll("shape=", "")
            ?.replaceAll("style=", "")
            ?.replaceAll("material=14K-", "")
        )
        ?.replaceAll("metals=", "")
        ?.replaceAll("metal=", "");
    }
    setSteps(1);
    setFiltersuccess(false);
    const data = {
      currency_code: currencycode,
      setting_id: JSON.parse(localStorage.getItem("dfl-settingdata"))
        ? JSON.parse(localStorage.getItem("dfl-settingdata"))?.product_id
        : "",
      diamond_type: diamond_type,
    };
    axios
      .post(base_url + "/diamond/diamond_filter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setFilter(res.data.data);
          setSortby(res.data.data?.sort_by[0]?.value);
          if (!JSON.parse(localStorage.getItem("dfl_d_filter"))?.price.length) {
            setPrice([
              res.data.data?.normal_filters?.price?.min,
              res.data.data?.normal_filters?.price?.max,
            ]);
          }
          if (!JSON.parse(localStorage.getItem("dfl_d_filter"))?.carat.length) {
            setCarat([
              res.data.data?.normal_filters?.carat?.min,
              res.data.data?.normal_filters?.carat?.max,
            ]);
          }
          res.data.data?.normal_filters?.shape?.map((val) =>
            val.selected == 1 ? setShape(val.value) : ""
          );
          setCaratrange(res.data.data?.normal_filters?.carat?.range);
          setPricerange(res.data.data?.normal_filters?.price?.range);
          setFiltersuccess(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [window.location.pathname]);
  useEffect(() => {
    if (window.location.pathname == "/diamonds/lab") {
      setDiamond_type(2);
      setCarat([]);
      setPrice([]);
    } else {
      setDiamond_type(1);
      setCarat([]);
      setPrice([]);
    }
    if (props.location.pathname?.includes("/diamonds/")) {
      setShape(
        props.location.pathname?.replace("/diamonds/", "") === "lab"
          ? ""
          : props.location.pathname?.replace("/diamonds/", "")
      );
    }
  }, [window.location.pathname]);
  useEffect(() => {
    let getCount = true;
    onchangesdata(getCount);
  }, [shape, sortby, inputchange, clearFdata, carat, price]);

  useEffect(() => {
    if (filtersuccess) {
      diamondlistdata(page == 1 ? true : false);
    }
  }, [page, filtersuccess, diamond_type]);

  const onchangesdata = (getCount) => {
    setPage(1);
    var data1 = {
      shape,
      carat,
      price,
      cutdata,
      colordata,
      claritydata,
      fluorescencedata,
      polishdata,
      symmetrydata,
      cut,
      color,
      clarity,
      fluorescence,
      polish,
      symmetry,
      sortby,
    };
    localStorage.setItem("dfl_d_filter", JSON.stringify(data1));
    // setInterval(async () => {diamondlistdata(); }, 3000);
    // setTimeout(diamondlistdata, 2000);
    if (filtersuccess && page == 1) {
      console.log("getCount", getCount)
      diamondlistdata(getCount);
    }
  };

    useEffect(async () => {
    if (filterCleared) {
      

      await diamondlistdata()
      setFilterCleared(false)
    }
  }, [filterCleared]) 
  const diamondListCount = async () => {
    var data = {
      currency_code: currencycode,
      start: (page - 1) * 16,
      length: 16,
      cut: cutdata,
      color: colordata,
      clarity: claritydata,
      flourescence: fluorescencedata,
      polish: polishdata,
      symmetry: symmetrydata,
      shape,
      price_to: price[1],
      price_from: price[0],
      carat_from: carat[0],
      carat_to: carat[1],
      sort_by: sortby,
      user_id: user.user_id ? user.user_id : "",
      session_id: localStorage.getItem("dfl-session-id")
        ? localStorage.getItem("dfl-session-id")
        : "",
      token: isLogin ? user.token : "",
      diamond_type: diamond_type,
      count: 1
    };
    await axios
      .post(base_url + "/diamond/diamond_list", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setTotalCount(res.data.data?.count);

          var count = (res.data.data?.count / 16).toFixed();
          if (count * 16 >= res.data.data?.count) {
            setProductCount(count);
          } else {
            setProductCount(Number(count) + 1);
          }
          setLoader(false);
          if (res.data.data?.count !== 0) {
            setCountLoader(false);
          } else {
            setCountLoader(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const diamondlistdata = async (getCount) => {
    setLoader(true);
    setCountLoader(true);
    setDiamondList([]);
    var data = {
      currency_code: currencycode,
      start: (page - 1) * 16,
      length: 16,
      cut: cutdata,
      color: colordata,
      clarity: claritydata,
      flourescence: fluorescencedata,
      polish: polishdata,
      symmetry: symmetrydata,
      shape,
      price_to: price[1],
      price_from: price[0],
      carat_from: carat[0],
      carat_to: carat[1],
      sort_by: sortby,
      user_id: user.user_id ? user.user_id : "",
      session_id: localStorage.getItem("dfl-session-id")
        ? localStorage.getItem("dfl-session-id")
        : "",
      token: isLogin ? user.token : "",
      diamond_type: diamond_type,
      count: 0
    };
    await axios
      .post(base_url + "/diamond/diamond_list", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          settitleHeading(res.data?.title);
          setDiamondList(res.data.data?.result);
          setLoader(false);
          if (getCount) {
            setTotalCount(0);
            setProductCount(0);
            diamondListCount();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const datasort = (obj, min, max) => {
    var data = Object.keys(obj)?.map((key) => [Number(key), obj[key]]);
    var result = [];
    var data1 = data
      .filter((val) => val[0] > min && val[0] <= max)
      ?.map((val) => result.push(val[1]));
    return result;
  };
  const handlecut = (value) => {
    if (value[0] != value[1]) {
      setCut(value);
      var obj = filter?.normal_filters?.cut;
      var data = datasort(obj, value[0], value[1]);
      setCutdata(data);
    }
  };
  const handlecolor = (value) => {
    if (value[0] != value[1]) {
      setColor(value);
      var obj = filter?.normal_filters?.color;
      var data = datasort(obj, value[0], value[1]);
      setColordata(data);
    }
  };
  const handleclarity = (value) => {
    if (value[0] != value[1]) {
      setClarity(value);
      var obj = filter?.normal_filters?.clarity;
      var data = datasort(obj, value[0], value[1]);
      setClaritydata(data);
    }
  };
  const handlefluorescence = (value) => {
    if (value[0] != value[1]) {
      setFluorescence(value);
      var obj = filter?.advance_filters?.fluorescence;
      var data = datasort(obj, value[0], value[1]);
      setFluorescencedata(data);
    }
  };
  const handlePolish = (value) => {
    if (value[0] != value[1]) {
      setPolish(value);
      var obj = filter?.advance_filters?.polish;
      var data = datasort(obj, value[0], value[1]);
      setPolishdata(data);
    }
  };
  const handleSymmetry = (value) => {
    if (value[0] != value[1]) {
      setSymmetry(value);
      var obj = filter?.advance_filters?.symmetry;
      var data = datasort(obj, value[0], value[1]);
      setSymmetrydata(data);
    }
  };
  const handleprice = (value) => {
    setPrice([value.from_value, value.to_value]);
  };
  const handlepriceinput = (i) => {
    var data = [];
    if (i == 0) {
      if (price[0] < filter?.normal_filters?.price?.min) {
        data = [filter?.normal_filters?.price?.min, price[1]];
      } else if (price[0] > filter?.normal_filters?.price?.max) {
        data = [filter?.normal_filters?.price?.max, price[1]];
      } else {
        data = [price[0], price[1]];
      }
    } else if (i == 1) {
      if (price[1] > filter?.normal_filters?.price?.max) {
        data = [price[0], filter?.normal_filters?.price?.max];
      } else if (price[1] < filter?.normal_filters?.price?.min) {
        data = [price[0], filter?.normal_filters?.price?.min];
      } else {
        data = [price[0], price[1]];
      }
    }
    if (data[0] < data[1]) {
      var data1 = [data[0], data[1]];
    } else {
      var data1 = [data[1], data[0]];
    }
    setPrice(data1);
    setInputchange(!inputchange);
  };
  const handlecarat = (value) => {
    setCarat([value.from_value, value.to_value]);
  };
  const handlecaratinput = (i) => {
    var data = [];
    if (i == 0) {
      if (carat[0] < filter?.normal_filters?.carat?.min) {
        data = [filter?.normal_filters?.carat?.min, carat[1]];
      } else if (carat[0] > filter?.normal_filters?.carat?.max) {
        data = [filter?.normal_filters?.carat?.max, carat[1]];
      } else {
        data = [carat[0], carat[1]];
      }
    } else if (i == 1) {
      if (carat[1] > filter?.normal_filters?.carat?.max) {
        data = [carat[0], filter?.normal_filters?.carat?.max];
      } else if (carat[1] < filter?.normal_filters?.carat?.min) {
        data = [carat[0], filter?.normal_filters?.carat?.min];
      } else {
        data = [carat[0], carat[1]];
      }
    }
    if (data[0] < data[1]) {
      var data1 = [Number(data[0]), Number(data[1])];
    } else {
      var data1 = [Number(data[1]), Number(data[0])];
    }
    setCarat(data1);
    setInputchange(!inputchange);
  };
  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  $(document).ready(function () {
    $("#ringsettingtable").DataTable();
  });

  const addtowishlist = (product_id, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: localStorage.getItem("dfl-session-id")
        ? localStorage.getItem("dfl-session-id")
        : "",
      product_id: product_id?.stock_no,
      type: "diamond",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          const productlist = diamondList?.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data?.wishlist_id })
              : obj
          );
          setDiamondList(productlist);
          dispatch(whishlistlength(res.data.data?.count));
        } else if (res.data.status == 2) {
          localStorage.removeItem("dfl-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          localStorage.removeItem("dfl-session-id");
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // const [expanded, setExpanded] = React.useState(false);
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>
          {diamond_type == 1 ? "Natural" : "Lab"} Diamonds | Diamonds For Less
        </title> */}
        <title>{metaData?.title}</title>
        <meta name="description" content={metaData?.description}></meta>
        {/* <meta
          name="description"
          content={
            diamond_type == 1
              ? "Buy natural diamonds at fair prices from us. We are leading sellers of diamonds across the country. Natural Diamonds"
              : "Lab-grown diamonds are the perfect choice for engagement rings, wedding bands and rings, and fine Jewellery. They provide excellent sparkle at a competitive price. | Diamonds For Less"
          }
        ></meta> */}
        <meta name="keywords" content={metaData?.keywords}></meta>
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        <Container className="rcs_shap-wizard_container">
          <Row>
            <Col className="rcs_breadcrumb mb-2">
              <Breadcrumbs aria-label="breadcrumb">
                <NavLink underline="hover" color="inherit" to="/">
                  Home
                </NavLink>
                <Typography color="text.primary">Diamonds</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          <Ringbildermenu location="diamond" />
          <Row className="w-100 m-auto justify-content-center align-item-center">
            <div className="rcs_diamonds_page_top_btn">
              <ul className="d-flex justify-content-center align-item-center">
                <li>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      history.push("/diamonds");
                      clearFilter();
                      setDiamond_type(1);
                    }}
                    className={diamond_type == 1 ? "active" : ""}
                  >
                    Earth-Mined
                  </Button>
                </li>
                <li>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      history.push("/diamonds/lab");
                      clearFilter();
                      setDiamond_type(2);
                    }}
                    className={diamond_type == 2 ? "active" : ""}
                  >
                    Lab-Grown
                  </Button>
                </li>
              </ul>
            </div>
          </Row>
          <Row className="w-100 m-auto rcs_diamond_filter_section rcs_diamond_filter_section_desktop pr-3">
            <Col sm={12} md={6} className="pl-md-0 mt-lg-5 mt-md-0 mb-5">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={2} className="p-0">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}{" "}
                    </>
                  ) : (
                    <h2 title="Diamond Shape">Shape</h2>
                  )}
                </Col>
                <Col xs={12} sm={10} className="p-0">
                  <ul className="action-area--soLSw table-align_filter--GVxiB">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={518}
                            height={42}
                          />
                        )}{" "}
                      </>
                    ) : (
                      filter?.normal_filters?.shape?.map((val) => (
                        <li
                          data-qa="ShapeFilter-Round"
                          onClick={() =>
                            shape == val.name
                              ? setShape("")
                              : setShape(val.name)
                          }
                          className={
                            val.status
                              ? shape == val.name
                                ? "longFilter--VqAB5 item--YBPgi selected--Qs8si"
                                : "longFilter--VqAB5 item--YBPgi"
                              : "longFilter--VqAB5 item--YBPgi diamond-filter-dis"
                          }
                        >
                          <span className="single-item-container--Xo5ic">
                            <span className="title--jqbwB">{val.name}</span>
                            <div className="filtered--yd5Rg"></div>
                            <img src={val.icon}></img>
                            {/* <span className="icon-round  selectionIcon icon--qAfox"></span> */}
                          </span>
                        </li>
                      ))
                    )}
                  </ul>
                </Col>
              </Row>
            </Col>
            <Col sm={12} md={6} className="pr-md-0 mt-lg-5 mb-md-0 mb-5">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={2} className="p-0">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}{" "}
                    </>
                  ) : (
                    <h2 title="Diamond Cut">Cut</h2>
                  )}
                </Col>
                <Col xs={12} sm={10} className="p-0">
                  <div className="rcs_cut_slider">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={518}
                            height={42}
                          />
                        )}{" "}
                      </>
                    ) : (
                      <Slider.Range
                        onAfterChange={() => onchangesdata(true)}
                        min={0}
                        allowCross={false}
                        marks={filter?.normal_filters?.cut}
                        step={null}
                        onChange={handlecut}
                        value={cut}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col sm={12} md={6} className="pl-md-0 mb-md-0 mb-5">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={2} className="p-0">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}{" "}
                    </>
                  ) : (
                    <h2 title="Diamond Color">Color</h2>
                  )}
                </Col>
                <Col xs={12} sm={10} className="p-0">
                  <div className="rcs_color_slider">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={518}
                            height={42}
                          />
                        )}{" "}
                      </>
                    ) : (
                      <Slider.Range
                        onAfterChange={() => onchangesdata(true)}
                        allowCross={false}
                        min={0}
                        marks={filter?.normal_filters?.color}
                        step={null}
                        onChange={handlecolor}
                        value={color}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col sm={12} md={6} className="pr-md-0 mb-3">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={2} className="p-0">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}{" "}
                    </>
                  ) : (
                    <h2 title="Diamond Carat">Carat</h2>
                  )}
                </Col>
                <Col xs={12} sm={10} className="p-0 pr-top-minus10">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={300}
                          height={35}
                          className="pr-top-10"
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={518}
                          height={42}
                          className="pr-top-10"
                        />
                      )}{" "}
                    </>
                  ) : (
                    <>
                      <div className="rcs_catat_slider">
                        {/* <Range
                          onAfterChange={() => onchangesdata(true)}
                          min={filter?.normal_filters?.carat?.min}
                          max={filter?.normal_filters?.carat?.max}
                          value={carat}
                          allowCross={false}
                          onChange={handlecarat}
                          tipFormatter={(value) => `${value}`}
                          range={range}

                        /> */}
                        <IonRangeSlider
                          type="double"
                          min={filter?.normal_filters?.carat?.min}
                          max={filter?.normal_filters?.carat?.max}
                          values={caratrange}
                          // onChange={handlecarat}
                          onFinish={(e) => handlecarat(e)}
                          from={caratrange.indexOf(carat[0])}
                          to={caratrange.indexOf(carat[1])}
                        />
                      </div>
                      <Row className="mt-2">
                        <ul className="rcs_price_range_input rcs_prince_input_diamond">
                          <li>
                            <InputGroup>
                              {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="number"
                                step={0.01}
                                name="min"
                                min={0}
                                value={carat[0]}
                                onChange={(e) => {
                                  if (caratrange.includes(e.target.value)) {
                                    setCarat([
                                      Number(e.target.value),
                                      Number(carat[1]),
                                    ]);
                                  } else {
                                    var ind = caratrange.find((val) => {
                                      return val > e.target.value;
                                    });
                                    caratrange.splice(
                                      caratrange.indexOf(ind),
                                      0,
                                      e.target.value
                                    );
                                    setCarat([
                                      Number(e.target.value),
                                      Number(carat[1]),
                                    ]);
                                  }
                                }}
                                onBlurCapture={() => handlecaratinput(0)}
                              />
                            </InputGroup>
                          </li>
                          <li>
                            <InputGroup>
                              {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="number"
                                step={0.01}
                                min={0}
                                name="max"
                                value={carat[1]}
                                onChange={(e) => {
                                  if (caratrange.includes(e.target.value)) {
                                    setCarat([
                                      Number(carat[0]),
                                      Number(e.target.value),
                                    ]);
                                  } else {
                                    var ind = caratrange.find((val) => {
                                      return val > e.target.value;
                                    });
                                    caratrange.splice(
                                      caratrange.indexOf(ind),
                                      0,
                                      e.target.value
                                    );
                                    setCarat([
                                      Number(carat[0]),
                                      Number(e.target.value),
                                    ]);
                                  }
                                }}
                                onBlurCapture={() => handlecaratinput(1)}
                              />
                            </InputGroup>
                          </li>
                        </ul>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
            <Col sm={12} md={6} className="pl-md-0 mb-md-0 mb60">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={2} className="p-0">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}{" "}
                    </>
                  ) : (
                    <h2 title="Diamond Clarity">Clarity</h2>
                  )}
                </Col>
                <Col xs={12} sm={10} className="p-0">
                  <div className="rcs_color_slider">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={518}
                            height={42}
                          />
                        )}{" "}
                      </>
                    ) : (
                      <Slider.Range
                        onAfterChange={() => onchangesdata(true)}
                        allowCross={false}
                        min={0}
                        marks={filter?.normal_filters?.clarity}
                        step={null}
                        onChange={handleclarity}
                        value={clarity}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col sm={12} md={6} className="pr-md-0 mb-4 d-none">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={2} className="p-0">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}{" "}
                    </>
                  ) : (
                    <></>
                  )}
                </Col>
                <Col xs={12} sm={10} className="p-0 pr-top-minus10 d-none">
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={300}
                          height={35}
                          className="pr-top-10"
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={518}
                          height={42}
                          className="pr-top-10"
                        />
                      )}{" "}
                    </>
                  ) : (
                    <>
                      <div className="rcs_catat_slider">
                        {/* <Range
                          onAfterChange={() => onchangesdata(true)}
                          min={filter?.normal_filters?.price?.min}
                          max={filter?.normal_filters?.price?.max}
                          onChange={handleprice}
                          value={price}
                          tipFormatter={(value) => `${value}`}
                          allowCross={false}
                        /> */}

                        {/* <Range allowCross={false} min={0} max={500000} defaultValue={[0, 500000]} /> */}
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="w-100 m-auto pt-3 rcs_diamond_filter_section d-block d-md-none">
            <Col
              xs={12}
              className="p-0 rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
            >
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChangeAccordion("panel1")}
                defaultExpanded={true}
              >
                <AccordionSummary
                  style={{ width: "100%" }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>
                    <strong>Diamonds Filter</strong>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="pt-0 pb-0">
                  <Typography className="mb-5 mt-3">
                    <Col sm={12} md={6} className="p-0 mt-3 mb-4">
                      <Row className="w-100 m-auto">
                        <Col xs={12} sm={2} className="p-0">
                          <h2 title="Diamond Shape">Shape</h2>
                        </Col>
                        <Col xs={12} sm={10} className="p-0 mt-2">
                          <ul className="action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color_shape">
                            {filter?.normal_filters?.shape?.map((val) => (
                              <li
                                data-qa="ShapeFilter-Round"
                                onClick={() =>
                                  shape == val.name
                                    ? setShape("")
                                    : setShape(val.name)
                                }
                                className={
                                  val.status
                                    ? shape == val.name
                                      ? "longFilter--VqAB5 item--YBPgi selected--Qs8si"
                                      : "longFilter--VqAB5 item--YBPgi"
                                    : "longFilter--VqAB5 item--YBPgi diamond-filter-dis"
                                }
                              >
                                <span className="single-item-container--Xo5ic">
                                  <span className="title--jqbwB">
                                    {val.name}
                                  </span>
                                  <div className="filtered--yd5Rg"></div>
                                  <img src={val.icon}></img>
                                  {/* <span className="icon-round  selectionIcon icon--qAfox"></span> */}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={12} md={6} className="pr-md-0 p-0 mb-md-0 mb-5">
                      <Row className="w-100 m-auto">
                        <Col xs={12} sm={2} className="p-0">
                          <h2 title="Diamond Cut">Cut</h2>
                        </Col>
                        <Col xs={12} sm={10} className="p-md-0 pl-2 pr-2">
                          <div className="rcs_cut_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata(true)}
                              allowCross={false}
                              min={0}
                              marks={filter?.normal_filters?.cut}
                              step={null}
                              onChange={handlecut}
                              value={cut}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={12} md={6} className="pl-md-0 p-0 mb-md-0 mb-5">
                      <Row className="w-100 m-auto">
                        <Col xs={12} sm={2} className="p-0">
                          <h2 title="Diamond Color">Color</h2>
                        </Col>
                        <Col xs={12} sm={10} className="p-md-0 pl-2 pr-2">
                          <div className="rcs_color_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata(true)}
                              allowCross={false}
                              min={0}
                              marks={filter?.normal_filters?.color}
                              step={null}
                              onChange={handlecolor}
                              value={color}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={12} md={6} className="pr-md-0 p-0 mb-3">
                      <Row className="w-100 m-auto">
                        <Col xs={12} sm={2} className="p-0">
                          <h2 title="Diamond Carat">Carat</h2>
                        </Col>
                        <Col xs={12} sm={10} className="p-md-0 pl-2 pr-2">
                          <div className="rcs_catat_slider">
                            <IonRangeSlider
                              type="double"
                              min={filter?.normal_filters?.carat?.min}
                              max={filter?.normal_filters?.carat?.max}
                              values={caratrange}
                              // onChange={handlecarat}
                              onFinish={(e) => handlecarat(e)}
                              from={caratrange.indexOf(carat[0])}
                              to={caratrange.indexOf(carat[1])}
                            />
                          </div>
                          <Row className="mt-2">
                            <ul className="rcs_price_range_input rcs_prince_input_diamond">
                              <li>
                                <InputGroup>
                                  {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="number"
                                    step={0.01}
                                    min={0}
                                    name="min"
                                    value={carat[0]}
                                    onChange={(e) => {
                                      if (caratrange.includes(e.target.value)) {
                                        setCarat([
                                          Number(e.target.value),
                                          Number(carat[1]),
                                        ]);
                                      } else {
                                        var ind = caratrange.find((val) => {
                                          return val > e.target.value;
                                        });
                                        caratrange.splice(
                                          caratrange.indexOf(ind),
                                          0,
                                          e.target.value
                                        );
                                        setCarat([
                                          Number(e.target.value),
                                          Number(carat[1]),
                                        ]);
                                      }
                                    }}
                                    onBlurCapture={() => handlecaratinput(0)}
                                  />
                                </InputGroup>
                              </li>
                              <li>
                                <InputGroup>
                                  {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="number"
                                    step={0.01}
                                    name="max"
                                    min={0}
                                    value={carat[1]}
                                    onChange={(e) => {
                                      if (caratrange.includes(e.target.value)) {
                                        setCarat([
                                          Number(carat[0]),
                                          Number(e.target.value),
                                        ]);
                                      } else {
                                        var ind = caratrange.find((val) => {
                                          return val > e.target.value;
                                        });
                                        caratrange.splice(
                                          caratrange.indexOf(ind),
                                          0,
                                          e.target.value
                                        );
                                        setCarat([
                                          Number(carat[0]),
                                          Number(e.target.value),
                                        ]);
                                      }
                                    }}
                                    onBlurCapture={() => handlecaratinput(1)}
                                  />
                                </InputGroup>
                              </li>
                            </ul>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={12} md={6} className="pl-md-0 p-0 mb-md-0 mb-5">
                      <Row className="w-100 m-auto">
                        <Col xs={12} sm={2} className="p-0">
                          <h2 title="Diamond Clarity">Clarity</h2>
                        </Col>
                        <Col xs={12} sm={10} className="p-md-0 pl-2 pr-2">
                          <div className="rcs_color_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata(true)}
                              min={0}
                              allowCross={false}
                              marks={filter?.normal_filters?.clarity}
                              step={null}
                              onChange={handleclarity}
                              value={clarity}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    {/* <Col sm={12} md={6} className="pr-md-0 p-0 mb-3">
                      <Row className="w-100 m-auto">
                        <Col xs={12} sm={2} className="p-0">
                          <h2 title="Diamond Price">Price</h2>
                        </Col>
                        <Col xs={12} sm={10} className="p-md-0 pl-2 pr-2">
                          <div className="rcs_catat_slider">
                            <IonRangeSlider type="double"
                              min={filter?.normal_filters?.price?.min}
                              max={filter?.normal_filters?.price?.max}
                              values={pricerange}
                              onFinish={(e) => handleprice(e)}
                              from={pricerange.indexOf(price[0])}
                              to={pricerange.indexOf(price[1])}
                            />
                          </div>
                          <Row className="mt-2">
                            <ul className="rcs_price_range_input rcs_prince_input_diamond">
                              <li className="rcs_price_range_input1">
                                <InputGroup>
                                  <InputGroup.Text>{currency}</InputGroup.Text>
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="int"
                                    name="min"
                                    value={price[0]}
                                    onChange={(e) =>
                                      setPrice([
                                        Number(e.target.value),
                                        Number(price[1]),
                                      ])
                                    }
                                    onBlurCapture={() => handlepriceinput(0)}
                                  />
                                </InputGroup>
                              </li>
                              <li className="rcs_price_range_input1">
                                <InputGroup>
                                  <InputGroup.Text>{currency}</InputGroup.Text>
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="int"
                                    name="max"
                                    value={price[1]}
                                    onChange={(e) =>
                                      setPrice([
                                        Number(price[0]),
                                        Number(e.target.value),
                                      ])
                                    }
                                    onBlurCapture={() => handlepriceinput(1)}
                                  />
                                </InputGroup>
                              </li>
                            </ul>
                          </Row>
                        </Col>
                      </Row>
                    </Col> */}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Col>
          </Row>
          <Row className="w-100 m-auto rcs_diamond_filter_section">
            <Col
              xs={12}
              className="p-0 mb-3 rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
            >
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChangeAccordion("panel2")}
              >
                <AccordionSummary
                  style={{ width: "100%" }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography>
                    <strong>Advance Filter</strong>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="pt-0 pb-0">
                  <Typography className="mb-5 mt-4">
                    <Row className="m-auto w-100 pr-3 mobile_device_pad_none">
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={12}
                        xl={6}
                        className="mb-5 pl-lg-0 pl-lg-2 pr-sm-2 pl-sm-2"
                      >
                        <Row className="w-100 m-auto">
                          <Col sm={2} md={12} lg={2} className="p-0 mb-md-3">
                            <h2 title="Diamond Fluorescence">Fluor</h2>
                          </Col>
                          <Col
                            sm={10}
                            md={12}
                            lg={10}
                            className="p-md-2 p-0 p-sm-0 p-lg-0"
                          >
                            <div className="rcs_fluorescence_slider">
                              <Slider.Range
                                onAfterChange={() => onchangesdata(true)}
                                allowCross={false}
                                min={0}
                                marks={filter?.advance_filters?.fluorescence}
                                step={null}
                                onChange={handlefluorescence}
                                value={fluorescence}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      {/* <Col xs={12} sm={12} md={6} lg={12} xl={6} className='p-lg-0 pr-xl-0 mb-5 pr-sm-2 pl-sm-2'> */}
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={12}
                        xl={6}
                        className="pr-lg-0 pr-xl-0 mb-5 pr-sm-2"
                      >
                        <Row className="w-100 m-auto">
                          <Col sm={2} md={12} lg={2} className="p-0 mb-md-3">
                            <h2 title="Diamond Polish">Polish</h2>
                          </Col>
                          <Col
                            sm={10}
                            md={12}
                            lg={10}
                            className="p-md-2 p-lg-0 p-0"
                          >
                            <div className="rcs_cut_slider">
                              <Slider.Range
                                onAfterChange={() => onchangesdata(true)}
                                allowCross={false}
                                min={0}
                                marks={filter?.advance_filters?.polish}
                                step={null}
                                onChange={handlePolish}
                                value={polish}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={12}
                        xl={6}
                        className="pl-lg-0 pr-sm-2 pl-sm-2"
                      >
                        <Row className="w-100 m-auto">
                          <Col sm={2} md={12} lg={2} className="p-0 mb-md-3">
                            <h2 title="Diamond Symmetry">Symmetry</h2>
                          </Col>
                          <Col
                            sm={10}
                            md={12}
                            lg={10}
                            className="p-md-2 p-0 p-sm-0 p-lg-0"
                          >
                            <div className="rcs_cut_slider">
                              <Slider.Range
                                onAfterChange={() => onchangesdata(true)}
                                allowCross={false}
                                min={0}
                                marks={filter?.advance_filters?.symmetry}
                                step={null}
                                onChange={handleSymmetry}
                                value={symmetry}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Col>

            <Col xs={12} className="p-0 mb-3">
              <Button
                variant="outlined"
                onClick={clearFilter}
                className="rcs_clear_filter"
              >
                <ReplayIcon /> Clear Filter
              </Button>
            </Col>
          </Row>

          <Row className="w-100 d-block m-auto">
            <Col xs={12} className="p-0">
              <div className="rcs_diamond_content">
                {/* <h4 className="text-center"> Curated selection of loose diamonds and designs </h4> */}
                <h1>
                  {titleHeading ? (
                    titleHeading
                  ) : (
                    <Skeleton
                      variant="text"
                      animation="wave"
                      className="m-auto"
                      width={200}
                      height={43}
                    />
                  )}{" "}
                </h1>
                {diamond_type == 1 ? (
                  <>
                    <p>Curated selection of loose diamonds and designs</p>
                    {/* <p>All diamonds are ethically mined and certified.</p> */}
                  </>
                ) : (
                  <p>
                    Diamonds grown in a laboratory are produced by experts in a
                    controlled lab environment, as opposed to natural diamonds,
                    which are mined. These lab-grown diamonds are called by
                    various names such as lab created diamonds, engineered
                    diamonds, synthetic diamonds or man-made diamonds.Explore
                    our collection of lab-grown diamonds in Canada, where you
                    can shop from a wide range of diamonds at wholesale prices.
                    You can filter through the diamond's shape, colour, clarity,
                    cut, and carat based on your preference and what goes best
                    with your jewellery. From{" "}
                    <b>
                      <Link
                        to="/engagement-rings-toronto"
                        className="Content_link_color"
                      >
                        engagement rings{" "}
                      </Link>
                    </b>{" "}
                    to timeless fine jewellery pieces, we offer customers an
                    opportunity to buy jewellery that not only looks good to the
                    eye but also aligns with their values.
                  </p>
                )}
              </div>
            </Col>
          </Row>

          <Row className="w-100 m-auto">
            <Col xs={12} className={view == 1 ? "" : "mb-5"}>
              <div className="rcs_product_list_wrapper mt-4 p-0 w-100">
                <div className="rcs_view p-0">
                  <Row className="w-100 m-auto">
                    <Col xs={6} className="p-0">
                      <div className="rcs_mob_filter1 rcs_ring_setting_filter">
                        {loader ? (
                          <>
                            <Skeleton
                              variant="text"
                              animation="wave"
                              className="m-auto"
                              width={150}
                              height={20}
                            />
                          </>
                        ) : (
                          <span> Showing {totalCount} Results </span>
                        )}
                      </div>
                    </Col>
                    <Col xs={6} className="p-0">
                      <div className="rcs_mob_filter1 rcs_ring_setting_filter1">
                        <span> View</span>
                        <AppsIcon
                          className={view == 1 ? "active_grid ml-2" : "ml-2"}
                          onClick={() => setView(1)}
                        />
                        <span style={{ borderRight: "1px solid #ccc" }}></span>
                        <ListIcon
                          className={view == 2 ? "active_grid ml-2" : "ml-2"}
                          onClick={() => setView(2)}
                        />
                        {/* <ul>                                                
                            <li><AppsIcon className={view == 1 ? "active_grid" : ""} onClick={() => setView(1)} /></li>
                            <li><span></span></li>
                            <li><ListIcon className={view == 2 ? "active_grid" : ""} onClick={() => setView(2)} /></li>
                        </ul> */}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="w-100 m-auto">
            <Col
              xs={12}
              sm={12}
              className="mt-3 rcs_diamond_table p-2 mb-md-3 mb-0"
            >
              <div
                className={
                  isMobileOnly
                    ? "rcs_sort_filter text-left p-0"
                    : "rcs_sort_filter float-right p-0"
                }
              ></div>
            </Col>
          </Row>
          {view == 2 ? (
            <Row className="w-100 d-block m-auto">
              <Col xs={12} className="rcs_diamond_table p-0">
                <Table
                  hover
                  responsive
                  size="sm"
                  className="rcs_diamonds_table"
                >
                  <thead>
                    <tr>
                      <th>Shape</th>
                      <th>Carat</th>
                      <th>Color</th>
                      <th>Clarity</th>
                      <th>Cut</th>
                      <th>Lab</th>
                      <th>Wishlist</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <>
                        {[...Array(17)].map((val) => (
                          <tr>
                            <td component="th" scope="row">
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      diamondList?.map((row, index) => (
                        <tr>
                          <td>{row.shape}</td>
                          <td>{row.weight}</td>
                          <td>{row.color}</td>
                          <td>{row.clarity}</td>
                          <td>{row.cut_grade}</td>
                          <td>{row.lab}</td>
                          <td
                            title="Add to Wishlist"
                            style={{ cursor: "pointer" }}
                          >
                            {row.is_wishlist == "0" ? (
                              <FavoriteBorderIcon
                                onClick={() => addtowishlist(row, index)}
                              />
                            ) : (
                              <FavoriteIcon
                                onClick={() => addtowishlist(row, index)}
                                className="animate__animated animate__heartBeat"
                              />
                            )}
                          </td>
                          <td>
                            <Button
                              onClick={() =>
                                window.open(
                                  "/diamonds-details/" + row.stock_no,
                                  "_blank"
                                )
                              }
                              variant="contained"
                            >
                              Details
                            </Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                <Stack spacing={2} className="mt-3 mb-3 rcs_diamond_pagination">
                  <Pagination
                    count={productCount}
                    page={page}
                    onChange={handlePageChange}
                    shape="rounded"
                  />
                </Stack>
              </Col>
            </Row>
          ) : (
            <>
              <Row className="dfl_diamonds_list_row">
                {loader ? (
                  <>
                    {[...Array(17)].map((val, index) => (
                      <>
                        {index == 5 ? (
                          <Col className="dfl_diamonds_list_item ">
                            <Skeleton
                              variant="text"
                              style={{
                                transform: "unset",
                                margin: "0 auto",
                                marginBottom: "10px",
                              }}
                              animation="wave"
                              height={640}
                            />{" "}
                          </Col>
                        ) : (
                          <Col className="dfl_diamonds_list_item">
                            <Skeleton
                              variant="text"
                              style={{
                                transform: "unset",
                                margin: "0 auto",
                                marginBottom: "15px",
                              }}
                              animation="wave"
                              height={300}
                            />
                          </Col>
                        )}
                      </>
                    ))}
                  </>
                ) : (
                  diamondList.map((row, index) => (
                    <>
                      {index == 5 ? (
                        <Col className="dfl_diamonds_list_item ">
                          <div className="dfl_diamonds_list_banner">
                            <img
                              src={placeholderImg}
                              alt="DFL daimond image"
                              className="img-fluid"
                            />
                            <div className="dfl_diamonds_list_banner_text">
                              <p>
                                See These Diamonds <strong>IN PERSON! </strong>
                              </p>
                              <p>
                                The <strong>ONLY</strong> Way You Should Buy A
                                Diamond!
                              </p>
                              <p>
                                {" "}
                                <NavLink to="/contact-us">
                                  <strong> Contact DFL</strong>
                                </NavLink>{" "}
                                To Find Out How.
                              </p>
                            </div>
                          </div>
                        </Col>
                      ) : (
                        ""
                      )}
                      <Col className="dfl_diamonds_list_item">
                        <div className="rcs_diamonds_grid_content">
                          {/* <span className="rcs_diamonds_grid_info" >
                              <img src="/static/media/inquir.9a98e4da.svg" /></span> */}
                          <span
                            className="rcs_diamonds_grid_wishlist"
                            style={{ cursor: "pointer" }}
                          >
                            {row.is_wishlist == "0" ? (
                              <FavoriteBorderIcon
                                onClick={() => addtowishlist(row, index)}
                              />
                            ) : (
                              <FavoriteIcon
                                onClick={() => addtowishlist(row, index)}
                                className="animate__animated animate__heartBeat"
                              />
                            )}
                          </span>

                          <NavLink
                            to={"/diamonds-details/" + row.stock_no}
                            target="_blank"
                          >
                            <img src={row.imagelink} alt="diamonds" className />
                          </NavLink>

                          <div className="rcs_product_info">
                            <NavLink
                              to={"/diamonds-details/" + row.stock_no}
                              target="_blank"
                            >
                              {" "}
                              <h3>{row.name}</h3>
                            </NavLink>

                            <div className="rcs_product_tooltip">
                              <span>
                                <MoreVertOutlinedIcon />
                              </span>
                              <div className="rcs_product_tooltip_content">
                                <div className="rcs_bg-slide">
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">Item:</div>
                                    <div className="rcs_right-align">
                                      {row.stock_no}
                                    </div>
                                  </li>
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">Carat:</div>
                                    <div className="rcs_right-align">
                                      {row.weight}
                                    </div>
                                  </li>
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">Color:</div>
                                    <div className="rcs_right-align">
                                      {row.color}
                                    </div>
                                  </li>
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">
                                      Clarity:
                                    </div>
                                    <div className="rcs_right-align">
                                      {row.clarity}
                                    </div>
                                  </li>
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">Cut:</div>
                                    <div className="rcs_right-align">
                                      {row.cut_grade}{" "}
                                    </div>
                                  </li>
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">
                                      Pol/sym
                                    </div>
                                    <div className="rcs_right-align">
                                      {row.polish}
                                    </div>
                                  </li>
                                  <li className="rcs_item-lists">
                                    <div className="rcs_left-align">
                                      Fluorescence
                                    </div>
                                    <div className="rcs_right-align">
                                      {row.fluorescence_color}
                                    </div>
                                  </li>
                                  {row.measurements == "" ? (
                                    ""
                                  ) : (
                                    <li className="rcs_item-lists">
                                      <div className="rcs_left-align">
                                        Measure
                                      </div>
                                      <div className="rcs_right-align">
                                        {row.measurements}
                                      </div>
                                    </li>
                                  )}
                                  {row.lab == "" ? (
                                    ""
                                  ) : (
                                    <li className="rcs_item-lists">
                                      <div className="rcs_left-align">lab</div>
                                      <div className="rcs_right-align">
                                        {row.lab}
                                      </div>
                                    </li>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </>
                  ))
                )}
              </Row>
              <Row className="mt-5 mb-3">
                <Col xs={6} className="pr-0 m-auto">
                  <div className="rcs_sorting_pagi">
                    <Stack
                      spacing={2}
                      className="mt-3 mb-3 rcs_diamond_pagination diamond_p"
                    >
                      <Pagination
                        count={productCount}
                        page={page}
                        onChange={handlePageChange}
                        shape="rounded"
                      />
                    </Stack>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default RingSettingsDiamonds;
